import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { GetPagePermissionFn } from "../../common/authority";
import { GetSpecialPermissionFn } from "../../common/authority";
import * as Comp from "../../common/CommonComponents";
import * as common from "../../common/common";
import http from "../../common/http-common";
import CssClass from "../../Styles/common.module.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import AddNewTicket from "../../components/Ticket/NewTicket/AddNewTicket";
import save from "../../assets/save-icon.png";
import reset from "../../assets/reset-icon.png";

const PAGE_NAME = "NewTicket.js";
const MODULE_ID = 'WEB_TKT_003';

const NewTicket = () => {
    document.title =  common.c_TITLE + " - New Ticket" ;
    const [cookies] = useCookies([]);
    const navigate = useNavigate();
    const userId = cookies.USER_ID;

    const [actionAuthority, setActionAuthority] = useState({
        READ: "N",
        WRITE: "N",
    });

    const [specialAuthority, setSpecialAuthority] = useState({
        ASSIGN_AGENT: "N",
        ASSIGN_TICKET_OWNER: "N",
    });

    useEffect(() => {
        let promise = GetSpecialPermissionFn(userId, MODULE_ID);
        promise.then(
          (result) => {
            setSpecialAuthority(result);
          },
          (error) => {
            setSpecialAuthority({
              ASSIGN_AGENT: "N",
              ASSIGN_TICKET_OWNER: "N",
            });
            common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
            toast.error(error);
          }
        );
      }, [actionAuthority, userId])

    useEffect(() => {
        let promise = GetPagePermissionFn(userId, MODULE_ID);
        promise.then(
            (result) => {
                setActionAuthority(result);
                if (result.READ === "N") {
                    navigate("/Home");
                }
            },
            (error) => {
                setActionAuthority({
                    READ: "N",
                    WRITE: "N",
                });
                common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
                toast.error(error);
                navigate("/Home");
            }
        );
    }, [userId, navigate]);

     // region style
     const thLabel = {
        // fontWeight: "700",
        fontSize: "0.875rem",
        textAlign: "center",
    }
    const delimeter = {
        marginLeft: "1rem",
        marginRight: "1rem",
        minWidth: "0px",
    }
    // end region style

    const optionsHour = [
        { key: "00", value: "00", label: "00" }, { key: "01", value: "01", label: "01" }, { key: "02", value: "02", label: "02" }, 
        { key: "03", value: "03", label: "03" }, { key: "04", value: "04", label: "04" }, { key: "05", value: "05", label: "05" }, 
        { key: "06", value: "06", label: "06" }, { key: "07", value: "07", label: "07" }, { key: "08", value: "08", label: "08" }, 
        { key: "09", value: "09", label: "09" }, { key: "10", value: "10", label: "10" }, { key: "11", value: "11", label: "11" }, 
        { key: "12", value: "12", label: "12" }, { key: "13", value: "13", label: "13" }, { key: "14", value: "14", label: "14" },
        { key: "15", value: "15", label: "15" }, { key: "16", value: "16", label: "16" }, { key: "17", value: "17", label: "17" }, 
        { key: "18", value: "18", label: "18" }, { key: "19", value: "19", label: "19" }, { key: "20", value: "20", label: "20" }, 
        { key: "21", value: "21", label: "21" }, { key: "22", value: "22", label: "22" }, { key: "23", value: "23", label: "23" },
      ];

      const optionsMinute = [
        { key: "00", value: "00", label: "00" }, { key: "01", value: "01", label: "01" }, { key: "02", value: "02", label: "02" }, 
        { key: "03", value: "03", label: "03" }, { key: "04", value: "04", label: "04" }, { key: "05", value: "05", label: "05" }, 
        { key: "06", value: "06", label: "06" }, { key: "07", value: "07", label: "07" }, { key: "08", value: "08", label: "08" }, 
        { key: "09", value: "09", label: "09" }, { key: "10", value: "10", label: "10" }, { key: "11", value: "11", label: "11" }, 
        { key: "12", value: "12", label: "12" }, { key: "13", value: "13", label: "13" }, { key: "14", value: "14", label: "14" },
        { key: "15", value: "15", label: "15" }, { key: "16", value: "16", label: "16" }, { key: "17", value: "17", label: "17" }, 
        { key: "18", value: "18", label: "18" }, { key: "19", value: "19", label: "19" }, { key: "20", value: "20", label: "20" }, 
        { key: "21", value: "21", label: "21" }, { key: "22", value: "22", label: "22" }, { key: "23", value: "23", label: "23" }, 
        { key: "24", value: "24", label: "24" }, { key: "25", value: "25", label: "25" }, { key: "26", value: "26", label: "26" }, 
        { key: "27", value: "27", label: "27" }, { key: "28", value: "28", label: "28" }, { key: "29", value: "29", label: "29" },
        { key: "30", value: "30", label: "30" }, { key: "31", value: "31", label: "31" }, { key: "32", value: "32", label: "32" }, 
        { key: "33", value: "33", label: "33" }, { key: "34", value: "34", label: "34" }, { key: "35", value: "35", label: "35" }, 
        { key: "36", value: "36", label: "36" }, { key: "37", value: "37", label: "37" }, { key: "38", value: "38", label: "38" }, 
        { key: "39", value: "39", label: "39" }, { key: "40", value: "40", label: "40" }, { key: "41", value: "41", label: "41" },
        { key: "42", value: "42", label: "42" }, { key: "43", value: "43", label: "43" }, { key: "44", value: "44", label: "44" },
        { key: "45", value: "45", label: "45" }, { key: "46", value: "46", label: "46" }, { key: "47", value: "47", label: "47" },
        { key: "48", value: "48", label: "48" }, { key: "49", value: "49", label: "49" }, { key: "50", value: "50", label: "50" },
        { key: "51", value: "51", label: "51" }, { key: "52", value: "52", label: "52" }, { key: "53", value: "53", label: "53" },
        { key: "54", value: "54", label: "54" }, { key: "55", value: "55", label: "55" }, { key: "56", value: "56", label: "56" },
        { key: "57", value: "57", label: "57" }, { key: "58", value: "58", label: "58" }, { key: "59", value: "59", label: "59" },
      ];

    // const [error, setError] = useState({});
    const [reload, setReload] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("Loading...");
    const [addData, setAddData] = useState([]);
    const [inputError, setInputError] = useState([]);   

    const [companyFieldDisabled, setCompanyFieldDisabled] = useState(false);
    const [systemFieldDisabled, setSystemFieldDisabled] = useState(false);
    const [ticketOwnerFieldDisabled, setTicketOwnerFieldDisabled] = useState(false);
    const [agentFieldDisabled, setAgentFieldDisabled] = useState(false);
    const [companyDetailList, setCompanyDetailList] = useState([]);
    const [systemDetailList, setSystemDetailList] = useState([]);
    const [priorityDetailList, setPriorityDetailList] = useState([]);
    const [categoryDetailList, setCategoryDetailList] = useState([]);
    const [ticketOwnerDetailList, setTicketOwnerDetailList] = useState([]);
    const [agentDetailList, setAgentDetailList] = useState([]);

    const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
    const [showSaveConfirmation, setShowSaveConfirmation] = useState(false);

    const [selectedCompanyDetail, setSelectedCompanyDetail] = useState([]);
    const [selectedSystemDetail, setSelectedSystemDetail] = useState([]);
    const [selectedTicketOwnerDetail, setSelectedTicketOwnerDetail] = useState([]);
    const [selectedAgentDetail, setSelectedAgentDetail] = useState([]);
    const [selectedPriorityDetail, setSelectedPriorityDetail] = useState({
        key: '25466b86-8fe8-4f73-9982-2ed4af591065', 
        value: '25466b86-8fe8-4f73-9982-2ed4af591065',
        label: 'NORMAL'
    });
    const [selectedCategoryDetail, setSelectedCategoryDetail] = useState({
        key: '4a89ae4f-523e-436a-8c04-9ff28aa44c91', 
        value: '4a89ae4f-523e-436a-8c04-9ff28aa44c91', 
        label: 'SYSTEM SUPPORT'
    });
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [columns, setColumns] = useState([]);
    var emptyFile = { name: " ", size: " " }
    const fileData = [...selectedFiles, emptyFile]

    const [dateFieldDisabled, setDateFieldDisabled] = useState(false)

    // const [selectedFiles, setSelectedFiles] = useState([]);

    // const handleFileChange = (event) => {
    //     const files = event.target.files;
    //     const newSelectedFiles = [];

    //     for (let i = 0; i < files.length; i++) {
    //         const file = files[i];
    //         if (file.size <= 4 * 1024 * 1024) { // 4MB size limit
    //             newSelectedFiles.push(file);
    //         } else {
    //             // You can show an error message here if needed
    //             toast.error(`File '${file.name}' exceeds 4MB size limit and won't be added.`);
    //         }
    //     }

    //     setSelectedFiles([...selectedFiles, ...newSelectedFiles]);
    //     event.target.value = null;
    //     setError({});
    // };

    const handleClearFiles = () => {
        setSelectedFiles([]);
    };

    // const calculateTotalSize = (files) => {
    //     let totalSize = 0;
    //     files.forEach(file => {
    //         totalSize += file.size;
    //     });
    //     return totalSize;
    // };

    // const fileInputText = selectedFiles.length > 0 ? `${selectedFiles.length} file(s) selected` : 'No files selected';

    // const [addData, setAddData] = useState({
    //     isValid: true,
    //     errorMessage: "",
    //     SUBJECT: "",
    //     TICKET_DETAILS: "",
    //     TARGET_MANDAYS: "",
    // });

    // #region UseEffect
    useEffect(() => {

        if (actionAuthority.READ === "Y") {
            setCompanyFieldDisabled(false);
            setCompanyDetailList([]);
            setSystemDetailList([]);
            setTicketOwnerDetailList([]);
            const listItems = [];

            try {
                http
                .get("api/NewTicket/GetCompanyDetail?_userId=" + userId, { timeout: 10000000 })
                .then((response) => {
                    if (response.data.length > 0) {
                        response.data.forEach((data, counter) => {
                            listItems.push({
                                key: data.ORG_ID,
                                value: data.ORG_ID,
                                label: data.ORG_NAME,
                            });
                        });
                        setCompanyDetailList(listItems);
                    }
                    if (response.data[0].ORG_CATEGORY_NAME === "CUSTOMER") {
                        setCompanyFieldDisabled(true);
                        setSelectedCompanyDetail({
                            key: response.data[0].ORG_ID,
                            value: response.data[0].ORG_ID,
                            label: response.data[0].ORG_NAME
                        });
                    }
                })
                .catch((err) => {
                    toast.error("Error on getting list. Please try again.");
                    common.c_LogWebError(PAGE_NAME, err.stack);
                })
                // .finally(()=>{

                // })
            } catch (err) {
                toast.error("Error on getting list. Please try again.");
                common.c_LogWebError(PAGE_NAME, err.stack);
            }
        }
    }, [actionAuthority, userId]);

    useEffect(() => {

        setSystemDetailList([]);
        const listItems = [];      

        try {

            http
            .get("api/NewTicket/GetSystemDetail?_userId=" + userId + "&_orgId=" + selectedCompanyDetail.value, { timeout: 10000000 })
            .then((response) => {
                if (response.data.length > 0) {
                    response.data.forEach((data, counter) => {
                        listItems.push({
                            key: data.SYSTEM_MST_ID,
                            value: data.SYSTEM_MST_ID,
                            label: data.SYSTEM_MST_NAME,
                        });
                    });
                    setSystemDetailList(listItems);
                }
                if (listItems.length === 1) {
                    setSystemFieldDisabled(true);
                    setSelectedSystemDetail(listItems[0])
                }
            })
            .catch((err) => {
                toast.error("Error on getting list. Please try again.");
                common.c_LogWebError(PAGE_NAME, err.stack);
            })
            // .finally(()=>{

            // })
        } catch (err) {
            toast.error("Error on getting list. Please try again.");
            common.c_LogWebError(PAGE_NAME, err.stack);
        }
    }, [selectedCompanyDetail, userId]);

    useEffect(() => {

        if (actionAuthority.READ === "Y") {
            setTicketOwnerFieldDisabled(false);
            setTicketOwnerDetailList([]);
            // setSystemDetailList([]);
            const listItems = [];

            try {
                http
                .get("api/NewTicket/GetTicketOwnerDetail?_userId=" + userId + "&_orgId=" + selectedCompanyDetail.value, { timeout: 10000000 })
                .then((response) => {
                    if (response.data.length > 0) {
                        response.data.forEach((data, counter) => {
                            listItems.push({
                                key: data.USER_ID,
                                value: data.USER_ID,
                                label: data.USER_SHORT_NAME,
                                isActive: data.ACTIVE_FLAG === "Y",
                            });
                        });
                        setTicketOwnerDetailList(listItems);
                    }
                    if (Array.isArray(response.data) && response.data.length > 0) {
                        if (response.data[0].ORG_CATEGORY_NAME === "CUSTOMER") {
                            setTicketOwnerFieldDisabled(true);
                            setSelectedTicketOwnerDetail({
                                key: response.data[0].USER_ID,
                                value: response.data[0].USER_ID,
                                label: response.data[0].USER_SHORT_NAME
                            });
                        } else if (listItems.length === 1) {
                            setTicketOwnerFieldDisabled(true);
                            setSelectedTicketOwnerDetail(listItems[0]);
                        }
                    }
                })
                .catch((err) => {
                    toast.error("Error on getting all user list. Please try again.1");
                    common.c_LogWebError(PAGE_NAME, err.stack);
                })
                // .finally(()=>{

                // })
            } catch (err) {
                toast.error("Error on getting all user list. Please try again.");
                common.c_LogWebError(PAGE_NAME, err.stack);
            }
        }
    }, [actionAuthority, selectedCompanyDetail, userId]);

    //#region Here Continue
    useEffect(() => {

        if (actionAuthority.READ === "Y") {
            setAgentFieldDisabled(false);
            setAgentDetailList([]);
            // setSystemDetailList([]);
            const listItems = [];

            try {
                http
                .get("api/NewTicket/GetAllAgent?_userId=" + userId, { timeout: 10000000 })
                .then((response) => {
                    console.log("Full API response:", response);
                    if (response.data.length > 0) {
                        console.log("Data length:", response.data.length);
                        response.data.forEach((data, counter) => {
                            listItems.push({
                                key: data.USER_ID,
                                value: data.USER_ID,
                                label: data.USER_SHORT_NAME,
                                isActive: data.ACTIVE_FLAG === "Y",
                            });
                        });
                        console.log("List items after processing getting all agent:", listItems);
                        setAgentDetailList(listItems);
                        console.log("Updated Agent Detail List: get all agent", listItems);
                    }
                    if (response.data[0].ORG_CATEGORY_NAME === "CUSTOMER") {
                        setAgentFieldDisabled(true);
                        setSelectedAgentDetail({
                            key: response.data[0].USER_ID,
                            value: response.data[0].USER_ID,
                            label: response.data[0].USER_SHORT_NAME
                        });
                    }
                })
                .catch((err) => {
                    toast.error("Error on getting all agent list. Please try again.1");
                    common.c_LogWebError(PAGE_NAME, err.stack);
                })
                // .finally(()=>{

                // })
            } catch (err) {
                toast.error("Error on getting all agent list. Please try again.");
                common.c_LogWebError(PAGE_NAME, err.stack);
            }
        }
    }, [actionAuthority, userId]);
    //#endregion

    useEffect(() => {

        setPriorityDetailList([]);
        const listItems = [];

        try {
            http.get("api/NewTicket/GetPriorityDetail?_userId=" + userId, { timeout: 10000000 })
                .then((response) => {
                    if (response.data.length > 0) {
                        response.data.forEach((data, counter) => {
                            listItems.push({
                                key: data.TICKET_PRIORITY_TYPE_ID,
                                value: data.TICKET_PRIORITY_TYPE_ID,
                                label: data.TICKET_PRIORITY_TYPE_NAME,
                            });
                        });
                        setPriorityDetailList(listItems);
                    }
                })
                .catch((err) => {
                    toast.error("Error on getting list. Please try again.");
                    common.c_LogWebError(PAGE_NAME, err.stack);
                })
            // .finally(()=>{

            // })
        } catch (err) {
            toast.error("Error on getting list. Please try again.");
            common.c_LogWebError(PAGE_NAME, err.stack);
        }
    }, [userId]);

    useEffect(() => {

        setCategoryDetailList([]);
        const listItems = [];

        try {
            http.get("api/NewTicket/GetCategoryDetail?_userId=" + userId, { timeout: 10000000 })
                .then((response) => {
                    if (response.data.length > 0) {
                        response.data.forEach((data, counter) => {
                            listItems.push({
                                key: data.TICKET_CATEGORY_ID,
                                value: data.TICKET_CATEGORY_ID,
                                label: data.TICKET_CATEGORY_NAME,
                            });
                        });
                        setCategoryDetailList(listItems);
                    }
                })
                .catch((err) => {
                    toast.error("Error on getting list. Please try again.");
                    common.c_LogWebError(PAGE_NAME, err.stack);
                })
            // .finally(()=>{

            // })
        } catch (err) {
            toast.error("Error on getting list. Please try again.");
            common.c_LogWebError(PAGE_NAME, err.stack);
        }
    }, [userId]);

    useEffect(() => {
        setColumns([
            {
                accessorFn: (row) => row.name,
                header: "Filename",
                size: "60",
            },
            {
                accessorFn: (row) => row.size === " " ? " " : formatSize(row.size),
                header: "Size",
                size: "10",
            },
            {
                id: "Action",
                header: "Action",
                size: "10",
                accessorFn: (row) => (
                    <div>
                        {row.name !== " "
                            ? <span>
                                <button
                                    style={{
                                        backgroundColor: "white",
                                        border: "none",
                                        alignItems: "center",
                                    }}
                                    onClick={(e) => clearFiles(e, row)}
                                >
                                    <CloseRoundedIcon />
                                </button>
                            </span>
                            : <span>
                                <button
                                    style={{
                                        backgroundColor: "white",
                                        border: "none",
                                    }}
                                    onClick={chooseFileFn}
                                >
                                    <AddRoundedIcon />
                                </button>
                            </span>}
                    </div>
                ),
            }
        ])
    }, [selectedFiles])

    const clearFiles = (e, row) => {
        const newData = [...selectedFiles];

        for (let i = 0; i < newData.length; i++) {

            if (newData[i] === row) {
                newData.splice(i, 1);
            }
        }
        setSelectedFiles(newData);
    }

    const selectFileHandler = (event) => {
        let functionName = "";

        try {
            functionName = selectFileHandler.name;
            const files = event.target.files;

            if (files.length === 0) {
                setSelectedFiles([]);
                setInputError((prevState) => ({
                    ...prevState,
                    ATTACHMENT: "",
                }));
            } else {
                for (let i = 0; i < files.length; i++) {
                    if (files[i].size <= 4 * 1024 * 1024) {
                        if (selectedFiles.some(file => file.name === files[i].name)) {
                            setInputError((prevState) => ({
                                ...prevState,
                                ATTACHMENT:
                                    files[i].name + " has already exist",
                            }));
                            toast.error(files[i].name + " has already exist");
                        }
                        else {
                            selectedFiles.push(files[i]);
                            setAddData((prevState) => ({
                                ...prevState,
                                ATTACHMENT: selectedFiles,
                            }));
                            setInputError((prevState) => ({
                                ...prevState,
                                ATTACHMENT: "",
                            }));
                        }
                    } else {
                        setInputError((prevState) => ({
                            ...prevState,
                            ATTACHMENT:
                                "Attachment file could not be exceeds 4MB size limit.",
                        }));
                        toast.error(files[i].name + " exceeds 4MB size limit");
                    }
                }

                event.target.value = null;

                setInputError((prevState) => ({
                    ...prevState,
                    ATTACHMENT: "",
                }));
            }
        } catch (err) {
            common.c_LogWebError(PAGE_NAME, functionName, err);
        }
    };

    function chooseFileFn() {
        document.getElementById("ATTACHMENT").click();
    }

    const formatSize = (bytes) => {
        const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        if (bytes === 0) return "0 Byte";
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    };
    //Function 

    const onReloadHandler = () => {
        setReload(!reload);
    };

    const onLoading = (load, text) => {
        let functionName = "";

        try {
            functionName = onLoading.name;

            setLoading(load);
            setLoadingText(text);
        } catch (err) {
            common.c_LogWebError(PAGE_NAME, functionName, err.stack);
        }
    };

    const selectCompanyDetailHandler = (val) => {
        let functionName = "";

        try {
            functionName = selectCompanyDetailHandler.name;

            if (Object.keys(val).length > 0) {
                setInputError((prevState) => ({
                    ...prevState,
                    COMPANY: "",
                }));
            } else {
                setInputError((prevState) => ({
                    ...prevState,
                    COMPANY: " could not be empty.",
                }));
            }

            setSelectedCompanyDetail(val)
            setSelectedSystemDetail([]);
            setSelectedTicketOwnerDetail([]);
            // setError({});

        } catch (err) {
            common.c_LogWebError(PAGE_NAME, functionName, err);
        }
    }

    const selectSystemDetailHandler = (val) => {
        let functionName = "";
        try {
            functionName = selectSystemDetailHandler.name;

            if (Object.keys(val).length > 0) {
                setInputError((prevState) => ({
                    ...prevState,
                    SYSTEM: "",
                }));
            } else {
                setInputError((prevState) => ({
                    ...prevState,
                    SYSTEM: " could not be empty.",
                }));
            }

            setSelectedSystemDetail(val)
            // setError({});

        } catch (err) {
            common.c_LogWebError(PAGE_NAME, functionName, err);
        }
    }

    const selectTicketOwnerDetailHandler = (val) => {
        let functionName = "";

        try {
            functionName = selectTicketOwnerDetailHandler.name;

            if (Object.keys(val).length > 0) {
                setInputError((prevState) => ({
                    ...prevState,
                    TICKET_OWNER: "",
                }));
            } else {
                setInputError((prevState) => ({
                    ...prevState,
                    TICKET_OWNER: " could not be empty.",
                }));
            }

            setSelectedTicketOwnerDetail(val)
            // setSelectedSystemDetail([]);
            // setError({});

        } catch (err) {
            common.c_LogWebError(PAGE_NAME, functionName, err);
        }
    }

    const selectAgentDetailHandler = (val) => {
        let functionName = "";

        try {
            functionName = selectAgentDetailHandler.name;

            if (Object.keys(val).length > 0) {
                setInputError((prevState) => ({
                    ...prevState,
                    AGENT: "",
                }));
            } else {
                setInputError((prevState) => ({
                    ...prevState,
                    AGENT: " could not be empty.",
                }));
            }

            setSelectedAgentDetail(val)
            // setSelectedSystemDetail([]);
            // setError({});

        } catch (err) {
            common.c_LogWebError(PAGE_NAME, functionName, err);
        }
    }


    const selectCategoryDetailHandler = (val) => {
        let functionName = "";
        try { 
            functionName = selectCategoryDetailHandler.name;

            if (Object.keys(val).length > 0) {
                setInputError((prevState) => ({
                    ...prevState,
                    CATEGORY: "",
                }));
            } else {
                setInputError((prevState) => ({
                    ...prevState,
                    CATEGORY: " could not be empty.",
                }));
            }

            setSelectedCategoryDetail(val)  
            // setError({});

        } catch (err) {
            common.c_LogWebError(PAGE_NAME, functionName, err);
        }
        
    }

    const selectPriorityDetailHandler = (val) => {
        let functionName = "";

        try {
            functionName = selectPriorityDetailHandler.name;

            if (Object.keys(val).length > 0) {
                setInputError((prevState) => ({
                    ...prevState,
                    PRIORITY: "",
                }));
            } else {
                setInputError((prevState) => ({
                    ...prevState,
                    PRIORITY: " could not be empty.",
                }));
            }

            setSelectedPriorityDetail(val)
            // setError({});
        } catch (err) {
            common.c_LogWebError(PAGE_NAME, functionName, err);
        }
    }

    const dateTimePickerHandler = (val, field) => {
        let functionName = "";
    
        try {
          functionName = dateTimePickerHandler.name;

            if (val === undefined || val === null) {
                setInputError((prevState) => ({
                    ...prevState,
                    [field]: "Could not be empty.",
                }));         
            } else {
                if (field === "FROM_DATETIME" && val < new Date()) {
                    toast.error("Invalid Start Date.");
                }

                if (field === "TO_DATETIME" && val < addData.FROM_DATETIME) {
                    toast.error("End Datetime must greater than Start Datetime.");
                } 

                setInputError((prevState) => ({
                    ...prevState,
                    [field]: "",
                }));               
            }
          
          setAddData((prevState) => ({
            ...prevState,
            [field]: val, 
          }));

        } catch (err) {
          common.c_LogWebError(PAGE_NAME, functionName, err);
        }
    };

    const inputRequiredHandler = (event) => {
        let functionName = "";
    
        try {
          functionName = inputRequiredHandler.name;
          const name = event.target.name;
          functionName = inputRequiredHandler.name + "_" + name;
          const id = event.target.id;
          const val = event.target.value;
          if (val.length === 0 || val.trim().length === 0) {
            setInputError((prevState) => ({
              ...prevState,
              [id]: name + " could not be empty.",
            }));
          } else {
            setInputError((prevState) => ({
              ...prevState,
              [id]: "",
            }));
          }
          setAddData((prevState) => ({
            ...prevState,
            [id]: val,
          }));
        } catch (err) {
          common.c_LogWebError(PAGE_NAME, functionName, err);
        }
      };

    const onInputChangeHandler = (event) => {
        const val = event.target.value;

        // Replace newline characters with spaces
        // const sanitizedValue = val.replace(/\n/g, ' ');

        setAddData((prevState) => ({
            ...prevState,
            [event.target.id]: val,
        }));
        // setError({});
    };

    const onCancelShowHandler = () => {
        setShowCancelConfirmation(true);
    }

    const onHideCancelConfirmationHandler = () => {
        setShowCancelConfirmation(false);
    }

    const onConfirmCancelConfirmationHandler = () => {
        onClearField();
        handleClearFiles();
        setShowCancelConfirmation(false);
        setInputError([]);
        // setError({});
    }

    const onClearField = () => {     
        setSelectedCategoryDetail({
            key: '4a89ae4f-523e-436a-8c04-9ff28aa44c91', 
            value: '4a89ae4f-523e-436a-8c04-9ff28aa44c91', 
            label: 'SYSTEM SUPPORT'
        });

        setSelectedPriorityDetail({
            key: '25466b86-8fe8-4f73-9982-2ed4af591065', 
            value: '25466b86-8fe8-4f73-9982-2ed4af591065', 
            label: 'NORMAL'
        });

        handleClearFiles();

        // setAddData({
        //     SUBJECT: "",
        //     TICKET_DETAILS: ""
        // })

        setAddData([]);

        

        if (companyFieldDisabled !== true) {
            setSelectedCompanyDetail([]);
        }
        
        if(systemFieldDisabled !== true){
            setSelectedSystemDetail([]);
        }

        if (ticketOwnerFieldDisabled !== true) {
            setSelectedTicketOwnerDetail([]);
        }
        
    }

    const onHideSaveConfirmationHandler = () => {
        setShowSaveConfirmation(false);
        setInputError([]);
        // setError({});
    }

    const SaveNewTicket = () => {
        let functionName = "";
        try {
            // if (ValidateField() === true) {
            //     setShowSaveConfirmation(true);
            // }
            functionName = PAGE_NAME + SaveNewTicket.name;
            setShowSaveConfirmation(true);
        } catch (err) {
            common.c_LogWebError(PAGE_NAME, err.stack);
        }
    }

    const checkBoxHandler = (event) => {
        let functionName = "";

        try {
            functionName = checkBoxHandler.name;
            const name = event.target.name;
            functionName = checkBoxHandler.name + "_" + name;
            const id = event.target.id;
            const val = event.target.checked;

            // setStandBy(val);
            setAddData((prevState) => ({
                ...prevState,
                [id]: val,
              }));
            setDateFieldDisabled(val);        
        } catch (err) {
          common.c_LogWebError(PAGE_NAME, functionName, err);
        }
      }

    const SaveBtnOnClick = () => {
        var flag = true;

        if (Object.keys(selectedCompanyDetail).length === 0) {
            flag = false;
            setInputError((prevState) => ({
                ...prevState,
                COMPANY: "Please select a company.",
            }));
        } else {
            setInputError((prevState) => ({
              ...prevState,
              COMPANY: "",
            }));
        }

        if (Object.keys(selectedSystemDetail).length === 0) {
            flag = false;
            setInputError((prevState) => ({
                ...prevState,
                SYSTEM: "Please select a system.",
            }));
        } else {
            setInputError((prevState) => ({
              ...prevState,
              SYSTEM: "",
            }));
        }

        if (addData.SUBJECT === undefined) {
            flag = false;
            setInputError((prevState) => ({
                ...prevState,
                SUBJECT: "Subject could not be empty.",
            }));
        }

        if (addData.TICKET_DETAILS === undefined) {
            flag = false;
            setInputError((prevState) => ({
                ...prevState,
                TICKET_DETAILS: "Detail could not be empty.",
            }));
        }

        if (addData.STANDBY_FLAG === true) {
            if (addData.FROM_DATETIME === undefined || addData.FROM_DATETIME === null) {
                flag = false;
                setInputError((prevState) => ({
                    ...prevState,
                    FROM_DATETIME: "Start datetime could not be empty.",
                }));
            }

            if (addData.TO_DATETIME === undefined || addData.TO_DATETIME === null) {
                flag = false;
                setInputError((prevState) => ({
                    ...prevState,
                    TO_DATETIME: "End datetime could not be empty.",
                }));
            }

            // if (addData.START_DATE === null) {
            //     flag = false;
            //     setInputError((prevState) => ({
            //         ...prevState,
            //         START_DATE: "Could not be empty.",
            //     }));
            // }

            // if (addData.END_DATE === null) {
            //     flag = false;
            //     setInputError((prevState) => ({
            //         ...prevState,
            //         END_DATE: "Could not be empty.",
            //     }));
            // }

            // if (addData.START_HOUR === undefined || addData.START_MIN === undefined) {
            //     flag = false;
            //     setInputError((prevState) => ({
            //         ...prevState,
            //         START_TIME: "Could not be empty.",
            //     }));
            // }

            // if (addData.END_HOUR === undefined || addData.END_MIN === undefined) {
            //     flag = false;
            //     setInputError((prevState) => ({
            //         ...prevState,
            //         END_TIME: "Could not be empty.",
            //     }));
            // }

        }

        if (Object.values(inputError).filter((v) => v !== "").length === 0 && flag
        ) {
            SaveNewTicket(); 
        }
    }

    // const ValidateField = () => {
    //     try {

    //         let isValid = true;
    //         // const fileSizeLimit = 4 * 1024 * 1024;
    //         const errorList = { ...error };

    //         if (selectedCompanyDetail.value === undefined) {
    //             errorList["COMPANY_VALID"] = false;
    //             errorList["COMPANY_ERROR"] =
    //                 "Please select company";
    //             isValid = false;
    //         }
    //         if (selectedSystemDetail.value === undefined) {
    //             errorList["SYSTEM_VALID"] = false;
    //             errorList["SYSTEM_ERROR"] =
    //                 "Please select system";
    //             isValid = false;
    //         }
    //         if (selectedCategoryDetail.value === undefined) {
    //             errorList["CATEGORY_VALID"] = false;
    //             errorList["CATEGORY_ERROR"] =
    //                 "Please select category";
    //             isValid = false;
    //         }
    //         if (selectedPriorityDetail.value === undefined) {
    //             errorList["PRIORITY_VALID"] = false;
    //             errorList["PRIORITY_ERROR"] =
    //                 "Please select priority";
    //             isValid = false;
    //         }
    //         if (addData.SUBJECT.trim() === undefined || addData.SUBJECT.trim() === "") {
    //             errorList["SUBJECT_VALID"] = false;
    //             errorList["SUBJECT_ERROR"] =
    //                 "Please enter subject";
    //             isValid = false;
    //         }
    //         if (addData.TICKET_DETAILS.trim() === undefined || addData.TICKET_DETAILS.trim() === "") {
    //             errorList["TICKET_DETAILS_VALID"] = false;
    //             errorList["TICKET_DETAILS_ERROR"] =
    //                 "Please enter details";
    //             isValid = false;
    //         }
    //         // selectedFiles.forEach((file, index) => {
    //         //     if (file.size > fileSizeLimit) {
    //         //         errorList["UPLOAD_VALID"] = false;
    //         //         errorList["UPLOAD_ERROR"] = "Each file size cannot exceed 4MB";
    //         //         isValid = false;
    //         //         // You can also update a specific error message for the file
    //         //         // errorList[`UPLOAD_ERROR_${index}`] = `${file.name} size exceeds 4MB`;
    //         //     }
    //         // })
    //         setError(errorList);
    //         return isValid;
    //     } catch (err) {

    //         common.c_LogWebError(PAGE_NAME, err.stack);

    //     }
    // }

    const messageCancel = (
        <>
            <span style={{ fontWeight: 'bold' }}>
                Are you confirm to reset all field?
            </span>
            <br />
        </>
    );

    // const formatSize = (bytes) => {
    //     const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    //     if (bytes === 0) return '0 Byte';
    //     const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    //     return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    // };

    return (

        <>
            <Comp.Header>
                New Ticket
            </Comp.Header>

            <div>
                <div style={{ padding: "0 1rem 0 1rem" }}>
                    <table className="table table-bordered table-hover">
                        <tbody>
                            <tr>
                                <td style={{ verticalAlign: "middle", width: "10%" }}>Company*</td>
                                <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
                                <td style={{ verticalAlign: "middle", width: "15%" }}>
                                    <Comp.Select
                                        id="COMPANY"
                                        type="text"
                                        options={companyDetailList}
                                        closeMenuOnSelect
                                        isDisabled={companyFieldDisabled}
                                        // isValid={error.COMPANY_VALID}
                                        errorMessage={inputError.COMPANY}        
                                        value={selectedCompanyDetail}
                                        onChange={selectCompanyDetailHandler}
                                    />
                                </td>
                                <td style={{ verticalAlign: "middle", width: "10%" }}>System*</td>
                                <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
                                <td style={{ verticalAlign: "middle", width: "15%" }}>
                                    <Comp.Select
                                        id="SYSTEM"
                                        type="text"
                                        options={systemDetailList}
                                        closeMenuOnSelect
                                        isDisabled={systemFieldDisabled}
                                        // isValid={error.SYSTEM_VALID}
                                        errorMessage={inputError.SYSTEM}
                                        value={selectedSystemDetail}
                                        onChange={selectSystemDetailHandler}                               
                                    />
                                </td>
                                {/* <td style={{ verticalAlign: "middle", width: "10%" }}></td>
                                <td style={{ verticalAlign: "middle", width: "1%" }}></td>
                                <td style={{ verticalAlign: "middle", width: "15%" }}>
                                </td> */}
                            </tr>
                            <tr>
                                {specialAuthority.ASSIGN_TICKET_OWNER === "Y" && (
                                <>
                                <td style={{ verticalAlign: "middle", width: "10%" }}>Ticket Owner*</td>
                                <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
                                <td style={{ verticalAlign: "middle", width: "15%" }}>
                                    <Comp.Select
                                        // className="d-none" // hide react-select
                                        closeMenuOnSelect
                                        id="TICKET_OWNER"
                                        type="text"
                                        isDisabled={ticketOwnerFieldDisabled}
                                        // isValid={error.CATEGORY_VALID}
                                        errorMessage={inputError.TICKET_OWNER}
                                        options={ticketOwnerDetailList.map(ticketOwner => ({
                                            ...ticketOwner,
                                            label: ticketOwner.isActive ? ticketOwner.label : `${ticketOwner.label} (INACTIVE)`
                                        }))}

                                        value={selectedTicketOwnerDetail}
                                        onChange={selectTicketOwnerDetailHandler}
                                    />
                                </td>
                                </>
                                )}
                                {specialAuthority.ASSIGN_AGENT === "Y" && (
                                <>
                                <td style={{ verticalAlign: "middle", width: "10%" }}>Assigned To*</td>
                                <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
                                <td style={{ verticalAlign: "middle", width: "15%" }}>
                                    <Comp.Select
                                        // className="d-none" 
                                        closeMenuOnSelect
                                        id="AGENT"
                                        type="text"
                                        isDisabled={agentFieldDisabled}
                                        // isValid={error.PRIORITY_VALID}
                                        errorMessage={inputError.AGENT}
                                        options={agentDetailList.map(agent => ({
                                            ...agent,
                                            label: agent.isActive ? agent.label : `${agent.label}  (INACTIVE)`
                                        }))}
                                        value={selectedAgentDetail}
                                        onChange={selectAgentDetailHandler}
                                    />
                                </td>
                                </>
                                )}
                            </tr>
                            <tr style={{display: "none"}}>
                                <td>Category*</td>
                                <td>:</td>
                                <td>
                                    <Comp.Select
                                        className="d-none" // hide react-select
                                        closeMenuOnSelect
                                        id="CATEGORY"
                                        type="text"
                                        // isValid={error.CATEGORY_VALID}
                                        errorMessage={inputError.CATEGORY}
                                        options={categoryDetailList}
                                        value={selectedCategoryDetail}
                                        onChange={selectCategoryDetailHandler}
                                    />
                                </td>
                                <td>Priority*</td>
                                <td>:</td>
                                <td>
                                    <Comp.Select
                                        className="d-none" 
                                        closeMenuOnSelect
                                        id="PRIORITY"
                                        type="text"
                                        // isValid={error.PRIORITY_VALID}
                                        errorMessage={inputError.PRIORITY}
                                        options={priorityDetailList}
                                        value={selectedPriorityDetail}
                                        onChange={selectPriorityDetailHandler}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>Title*</td>
                                <td>:</td>
                                <td colSpan="7">
                                    <Comp.Input
                                        id="SUBJECT"
                                        name="Subject"
                                        type="text"
                                        // isValid={error.SUBJECT_VALID}
                                        errorMessage={inputError.SUBJECT}
                                        className="form-control"
                                        value={addData.SUBJECT}
                                        onChange={inputRequiredHandler}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>Detail*</td>
                                <td>:</td>
                                <td colSpan="7">
                                    <Comp.TextArea
                                        id="TICKET_DETAILS"
                                        name="Detail"
                                        type="text"
                                        rows="5"  // This sets the number of rows to 5
                                        // isValid={error.TICKET_DETAILS_VALID}
                                        errorMessage={inputError.TICKET_DETAILS}
                                        className="form-control"
                                        value={addData.TICKET_DETAILS}
                                        onChange={inputRequiredHandler}
                                    />
                                </td>
                            </tr>
                            {/* <tr>
                                <td>Upload File <br />(Max.File Size 4MB per file)</td>
                                <td>:</td>
                                <td>
                                    <Comp.Input
                                        multiple
                                        type="file"
                                        accept=".xls, .xlsx, .pdf, .jpg, .jpeg, .png"
                                        onChange={handleFileChange}
                                        isValid={error.UPLOAD_VALID}
                                        errorMessage={error.UPLOAD_ERROR}
                                    />
                                </td>
                                <td>
                                    {selectedFiles.map((file, index) => (
                                        <li key={index}>
                                            {file.name} - {formatSize(file.size)}
                                            {file.size > 4 * 1024 * 1024 && (
                                                <span style={{ color: 'red' }}> - File size exceeds 4MB</span>
                                            )}
                                        </li>
                                    ))}
                                    <br />
                                    <div>{fileInputText}
                                    </div>{selectedFiles.length > 0 && (
                                        <div >Total Size: {formatSize(calculateTotalSize(selectedFiles))}</div>
                                    )}
                                    <br />
                                    {selectedFiles.length === 0 ? (
                                        ""
                                    ) : (
                                        <Comp.Button style={{ backgroundColor: 'red' }} onClick={handleClearFiles}>
                                            Clear
                                        </Comp.Button>
                                    )}
                                </td>
                                <td colSpan="5"></td>
                            </tr> */}
                            <tr>
                                <Comp.Input
                                    id="ATTACHMENT"
                                    type="file"
                                    className="form-control"
                                    label="Upload File (Max. File Size 4MB):"
                                    name="Upload File"
                                    value={addData.ATTACHMENT}
                                    onChange={selectFileHandler}
                                    // onChange={handleFileEvent}
                                    accept=".xls, .xlsx, .pdf, .jpg, .jpeg, .png"
                                    errorMessage={inputError.ATTACHMENT}
                                    // hidden={selectedFiles.length !== 0}
                                    hidden={true}
                                    multiple
                                />
                            </tr>
                            <tr>
                                <td>
                                    Upload File
                                    <br/> 
                                    <strong>
                                        (Max.File Size 4MB per file)
                                    </strong>                              
                                </td>
                                <td>:</td>
                                <td  colSpan="7"><Comp.Table data={fileData} columns={columns} enableTopToolbar={false}/></td>
                            </tr>
                            <tr>
                                <td>Standby</td>
                                <td>:</td>
                                <td colSpan="7">
                                    <Comp.Input
                                        id="STANDBY_FLAG"
                                        type="checkbox"
                                        className=""
                                        // label="Stand by:"
                                        name="Stand By"
                                        checked={addData.STANDBY_FLAG}
                                        onChange={checkBoxHandler}
                                    />
                                    {addData.STANDBY_FLAG === true && <div>
                                        {/* <div style={{display: "flex", flexDirection: "row", marginBottom: "1rem"}}>
                                            <label className={CssClass.inputLabel}>
                                                Target Mandays*:
                                            </label>
                                            <Comp.Input
                                                id="TARGET_MANDAYS"
                                                type="text"
                                                errorMessage={inputError.TARGET_MANDAYS}
                                                className="form-control"
                                                value={addData.TARGET_MANDAYS}
                                                onChange={inputRequiredHandler}
                                            />
                                        </div> */}

                                        <table className="table table-bordered" style={{width: "700px"}}>
                                            <thead>
                                                <tr>
                                                    <td style={thLabel}><strong>Start Datetime</strong><br/> (dd/mm/yyyy hh:mm)*</td>
                                                    <td style={thLabel}><strong>End Datetime</strong><br/>  (dd/mm/yyyy hh:mm)*</td>
                                                </tr> 
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{textAlign: "center"}}>
                                                        <Comp.DateTimePicker
                                                            // label="Start Date Time:"
                                                            id="FROM_DATETIME"
                                                            className="form-control"
                                                            errorMessage={inputError.FROM_DATETIME}
                                                            showTimeSelect
                                                            dateFormat="dd/MM/yyyy HH:mm"
                                                            timeFormat="HH:mm"
                                                            timeIntervals={1}
                                                            selected={addData.FROM_DATETIME}
                                                            onChange={(val) => dateTimePickerHandler(val, "FROM_DATETIME")}
                                                            // selected={startDate}
                                                            // onChange={setStartDate}
                                                            // disabled={!dateFieldDisabled}
                                                        />
                                                    </td>                                                   
                                                    <td style={{textAlign: "center"}}>
                                                        <Comp.DateTimePicker
                                                            // label="End Date:"
                                                            id="TO_DATETIME"
                                                            className="form-control"
                                                            errorMessage={inputError.TO_DATETIME}
                                                            showTimeSelect
                                                            dateFormat="dd/MM/yyyy HH:mm"
                                                            timeFormat="HH:mm"
                                                            timeIntervals={1}
                                                            selected={addData.TO_DATETIME}
                                                            onChange={(val) => dateTimePickerHandler(val, "TO_DATETIME")}
                                                            // selected={endDate}
                                                            // onChange={setEndDate}
                                                            // disabled={!dateFieldDisabled}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
               
                                        {/* <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <td style={thLabel}>Start Date*</td>
                                                    <td style={thLabel}>Start Time (hh:mm)*</td>
                                                    <td style={thLabel}>End Date*</td>
                                                    <td style={thLabel}>End Time (hh:mm)*</td>
                                                </tr> 
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <Comp.DateTimePicker
                                                            // label="Start Date:"
                                                            id="START_DATE"
                                                            className="form-control"
                                                            errorMessage={inputError.START_DATE}
                                                            selected={addData.START_DATE}
                                                            onChange={(val) => selectionHandler(val, "START_DATE")}
                                                            // selected={startDate}
                                                            // onChange={setStartDate}
                                                            // disabled={!dateFieldDisabled}
                                                        />
                                                    </td>
                                                    <td>
                                                        <div style={{display: "flex", flexDirection: "row"}}>
                                                            <Comp.Select
                                                                id="START_HOUR"
                                                                name="Start Hour"
                                                                options={optionsHour}
                                                                closeMenuOnSelect
                                                                errorMessage={inputError.START_TIME}        
                                                                value={addData.START_HOUR}
                                                                onChange={(val) => selectionHandler(val, "START_HOUR")}
                                                            />
                                                            <label style={delimeter}>:</label>
                                                            <Comp.Select                                                               
                                                                id="START_MIN"
                                                                name="Start Minute"
                                                                options={optionsMinute}
                                                                closeMenuOnSelect
                                                                errorMessage={inputError.START_TIME}        
                                                                value={addData.START_MIN}
                                                                onChange={(val) => selectionHandler(val, "START_MIN")}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <Comp.DateTimePicker
                                                            // label="End Date:"
                                                            id="END_DATE"
                                                            className="form-control"
                                                            errorMessage={inputError.END_DATE}
                                                            selected={addData.END_DATE}
                                                            onChange={(val) => selectionHandler(val, "END_DATE")}
                                                            // selected={endDate}
                                                            // onChange={setEndDate}
                                                            // disabled={!dateFieldDisabled}
                                                        />
                                                    </td>
                                                    <td>
                                                        <div style={{display: "flex", flexDirection: "row"}}>
                                                            <Comp.Select
                                                                id="END_TIME"
                                                                name="End Hour"
                                                                options={optionsHour}
                                                                closeMenuOnSelect
                                                                errorMessage={inputError.END_TIME}        
                                                                value={addData.END_HOUR}
                                                                onChange={(val) => selectionHandler(val, "END_TIME")}
                                                            />
                                                            <label style={delimeter}>:</label>
                                                            <Comp.Select
                                                                id="END_TIME"
                                                                name="End Minute"
                                                                options={optionsMinute}
                                                                closeMenuOnSelect
                                                                errorMessage={inputError.END_TIME}        
                                                                value={addData.END_MIN}
                                                                onChange={(val) => selectionHandler(val, "END_TIME")}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>    */}
                                    </div>}
                                </td>
                            </tr>                    
                        </tbody>
                    </table>

                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                        <Comp.Button onClick={SaveBtnOnClick}>
                            SAVE  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
                        </Comp.Button>
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <Comp.Button id="btnCancel" type="cancel" onClick={onCancelShowHandler}>
                            RESET  <img src={reset} alt="Reset" style={{ width: "20px", height: "20px", marginLeft: "2px", marginBottom: "2px" }} />
                        </Comp.Button>
                    </div>
                </div>
            </div>

            <Comp.ConfirmModal
                confirm
                show={showCancelConfirmation}
                onHide={onHideCancelConfirmationHandler}
                onConfirm={onConfirmCancelConfirmationHandler}
            >
                {messageCancel}
            </Comp.ConfirmModal>

            <AddNewTicket
                page={PAGE_NAME}
                module={MODULE_ID}
                userId={userId}
                show={showSaveConfirmation}
                onClear={onClearField}
                onHide={onHideSaveConfirmationHandler}
                addData={addData}
                companyDetail={selectedCompanyDetail}
                systemDetail={selectedSystemDetail}
                ticketOwner={selectedTicketOwnerDetail}
                agent={selectedAgentDetail}
                categoryDetail={selectedCategoryDetail}
                priorityDetail={selectedPriorityDetail}
                selectedFiles={selectedFiles}
                onReload={onReloadHandler}
                onLoading={onLoading}
            />

            {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
            <Comp.AlertPopup />
        </>
    );
};

export default NewTicket;
